"use client"

import { useEffect, useState, memo } from "react"
import MainLayout from "@/layout/MainLayout"
import StandardCard from "@/components/cards/StandardCard"
import { LISTING_GRID_CLASS, renderNewsGridWithAds } from "@/components/ListingGridWithAds"
import { useSearchParams } from "next/navigation"
import axiosInstance from "@/lib/axios"
import PageHeader from "@/components/ui/PageHeader"
import { LISTING_NEWS_PER_PAGE } from "@/lib/advertisement/constants"
import { CardGridSkeleton, EmptyState } from "@/components/ui/Skeleton"
import Pagination from "@/components/ui/Pagination"

const TrendingNews = () => {
    const searchParams = useSearchParams()
    const categoryId = searchParams.get('categoryId')
    const categoryName = searchParams.get('categoryName')

    const [news, setNews] = useState([])
    const [pagination, setPagination] = useState({})
    const [loading, setLoading] = useState(true)
    const [currentPage, setCurrentPage] = useState(1)

    const fetchTrending = async (page = 1) => {
        try {
            setLoading(true)
            const response = await axiosInstance.get('/news/trending', {
                params: { categoryId, page, limit: LISTING_NEWS_PER_PAGE }
            })
            if (response.data.success) {
                setNews(response.data.data)
                setPagination(response.data.pagination)
            }
        } catch (error) {
            console.error("Error fetching trending news:", error)
        } finally {
            setLoading(false)
            window.scrollTo({ top: 0, behavior: 'smooth' })
        }
    }

    useEffect(() => {
        setCurrentPage(1)
    }, [categoryId])

    useEffect(() => {
        fetchTrending(currentPage)
    }, [categoryId, currentPage])

    const title = 'ट्रेंडिंग बातम्या'
    const description = 'संपूर्ण महाराष्ट्रातील सध्याच्या सर्वात लोकप्रिय बातम्या.'

    return (
        <MainLayout>
            <PageHeader
                title={title}
                description={description}
                accentName="Trending"
            />

            {loading && !news.length ? (
                <CardGridSkeleton count={9} />
            ) : news.length > 0 ? (
                <>
                    <div className={LISTING_GRID_CLASS}>
                        {renderNewsGridWithAds(news, 'trending', (item) => (
                            <StandardCard
                                key={item.id}
                                layout="col"
                                headline={item.title}
                                imageUrl={item.featuredImage}
                                data={item}
                            />
                        ))}
                    </div>

                    {pagination.totalPages > 1 && (
                        <div className="mt-12">
                            <Pagination
                                currentPage={pagination.currentPage}
                                totalPages={pagination.totalPages}
                                onPageChange={setCurrentPage}
                            />
                        </div>
                    )}
                </>
            ) : (
                <EmptyState message="सध्या कोणतीही ट्रेंडिंग बातमी उपलब्ध नाही." />
            )}
        </MainLayout>
    )
}

export default memo(TrendingNews)
